import {useState} from 'react'
import {useUser} from "@/biz/user.mjs"
import {useIsProjectMember} from "@/biz/projectMember.mjs"

export default permission => {
    const {isPlatformAdm, pkid: userId} = useUser()
    const [prjId, setPrjId] = useState()
    const isMember = useIsProjectMember(prjId)

    if (permission) {
        return {}
    }

    const resetPermission = map => {
        if ('0' !== isPlatformAdm) {
            map.permission.add('revise')
            map.permission.add('write')
        }
        else {
            if (isMember) {
                map.permission.add('revise')
            }

            const {
                crtId,
                mapStsCode,
                mapTypeCode,
                prjTypeCode,
                uptId,
            } = map.data

            if (
                (
                    (
                        'REVISE' === mapStsCode &&
                        uptId === userId
                    ) ||
                    (
                        'DRAFT' === mapStsCode &&
                        crtId === userId
                    )
                ) &&

                (
                    'DEP_MAP' !== mapTypeCode ||
                    'ONLINE' === prjTypeCode
                )
            ) {
                map.permission.add('write')
            }
            else {
                map.permission.delete('write')
            }
        }
    }

    const extensions = map => {
        setPrjId(map.data.prjId)
        resetPermission(map)
    }

    const watchers = {
        load() {
            resetPermission(this)
        },

        meta_change() {
            resetPermission(this)
        }
    }

    return {extensions, watchers}
}
